'use client';

import React from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';

import { Media } from '@/components/Media';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselControls,
} from '@ui/carousel';
import { RichText } from '@/components/RichText';
import { CMSLink } from '@/components/Link';
import { ArrowForLink } from '@/components/ArrowForLink';
import type { FeaturesGlobalWidget } from '@/payload-types';
import { NAV } from '@/constants';

export const WeCureSlider: React.FC<{
  title: string;
  description: SerializedEditorState;
  features: FeaturesGlobalWidget['value'];
}> = ({ title, description, features }) => {
  return (
    <section className="v-margin" data-name="WeCureSlider">
      <div className="container">
        <h2 className="h2 mb-[49px] max-w-[880px] md:mb-5">{title}</h2>
        <RichText
          className="mb-[66px] max-w-[616px] md:mb-8"
          data={description}
        />

        <Carousel opts={{ align: 'start', loop: true }}>
          <CarouselContent className="-ml-6">
            {features?.map((i, idx) => (
              <CarouselItem
                className="flex basis-1/4 pl-6 md:basis-full"
                key={i.id}
              >
                <CMSLink
                  className="corners-sm group text-blue relative flex min-h-[288px] w-full flex-col gap-[23px] border border-gray-500 p-[23px] sm:gap-3 sm:p-[15px] md:min-h-[190px]"
                  {...i.link}
                >
                  <div className="w-12 md:w-10">
                    <Media resource={i.image} />
                  </div>
                  <div className="w-full max-w-[216px]">
                    <h4 className="h5">{i.title}</h4>
                    {i.description && (
                      <p className="mt-[7px]">{i.description}</p>
                    )}
                  </div>
                  <ArrowForLink className="mt-auto ml-auto" />
                </CMSLink>
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselControls linkText="Все услуги" linkUrl={NAV.serviceList} />
        </Carousel>
      </div>
    </section>
  );
};
